export enum categorieEquipementTypes {
    LOADING = "LOADING",
    SELECTED_CATEGORIE_EQUIPEMENT = "SELECTED_CATEGORIE_EQUIPEMENT",
    GET_CATEGORIE_EQUIPEMENT_LIST = "GET_CATEGORIE_EQUIPEMENT_LIST",
}
  
export default categorieEquipementTypes;